/* eslint-disable react-hooks/exhaustive-deps */

/* Protopia Ecosystem component */
import { useEffect, useRef } from "react"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { CardsContent, ITimelineCard } from "src/modules/pe-landing-module/data/interfaces"
import { ICardsProps } from "../../Cards"
import HorizontalTimelineDot from "./HorizontalTimelineDot"

 
export interface IHorizontalTimelineDiagramProps extends ICardsProps {
    onCurrent: ( cur: number)  => void
    current: number
}
const PADDING = 10
const HorizontalTimelineDiagram = (props: IHorizontalTimelineDiagramProps): JSX.Element => {
    const ref = useRef<HTMLDivElement>(null)
    const data: CardsContent        = { ...props.data } 
    const is_two_side               = data.is_two_side 
    const cards: ITimelineCard[]    = data.cards as ITimelineCard[]
    const perimeter                 = data.dots.perimeter 
    const path                      = useSyncState<string>( "" )    
    const w                         = useSyncState<number>( 0 )
    const h                         = useSyncState<number>( 50 ) 

    useEffect(() => {
        const _this                             = ref.current as HTMLDivElement
        const cardsElement: HTMLDivElement      = _this.closest(`.pe-cards-container`) as HTMLDivElement
        w.set( cardsElement.clientWidth )
        h.set( Math.max( data.dots.perimeter, data.dots.stroke_width ) )
        const p = perimeter / 2
        const y = p
        path.set(`M0 ${ y },${ w.get() } ${ y }Z`)
    }, [ props.data ])

    return <div 
        className={`landing-h-timeline position-relative`} 
        style={{
            paddingBottom: PADDING,
        }} 
        ref={ref}
    > 
        <svg 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" 
            y="0px"
            width={ w.get() }
            height={ h.get() }
            viewBox={`0 0 ${ w.get() } ${ h.get() }`}
            xmlSpace="preserve"
            className="" 
        >
            <path 
                fill="none" 
                strokeWidth={data.dots?.stroke_width }
                stroke={ 
                    data.dots?.svg_style?.stroke 
                        ? 
                        data.dots?.svg_style.stroke 
                        : 
                        "var(--force-contast-color)" 
                }
                strokeMiterlimit="10"  
                style={data.dots?.svg_style} 
                d={path.get()}
            />
        </svg>
        {
            cards.map(( card, i ) => {
                return <HorizontalTimelineDot 
                    dot={ card } 
                    data={ data } 
                    section={ props.section } 
                    containerWidth={ w.get() }
                    i={ i } 
                    key={ card.id }
                    onClick={() => props.onCurrent( i )}
                    isActive={i === props.current}
                />
            })
        } 
    </div>
}
export default HorizontalTimelineDiagram